import styles from "./Editor.module.sass";
import cn from "classnames";
import { Editor as ReactEditor } from "react-draft-wysiwyg";
import { UploadImage } from "../../Services/lib/admin";
import { UseApi } from "../../hooks/use-api";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Tooltip from "../Tooltip";
import Loader from "../Loader";

export const editorConfig = {
	readonly: false,
	zIndex: 0,
	height: 500,
	width: "100%",
	enter: "P",

	removeButtons: [
		"source",
		"about",
		"outdent",
		"indent",
		"video",
		"print",
		// "image",
		// "fontsize",
		"superscript",
		"subscript",
		"file",
		"cut",
		"selectall",
		"lineHeight",
		"font",
		"spellcheck",
		"paste",
		"copy",
		// "paint",
		"copyformat",
		"speechRecognize",
		"hr",
		"symbols",
		"ai-commands",
		"ai-assistant",
		"find",
		"preview",
		"classSpan",
		"fullsize",
	],
	buttons: [
		"bold",
		"italic",
		"underline",
		"strikethrough",
		"eraser",
		"|",
		// "ul",
		// "ol",
		// "|",
		"fontsize",
		"paragraph",
		"|",
		"outdent",
		"indent",
		"align",
		"|",
		"hr",
		"|",
		"brush",
		"|",
		"table",
		"link",
		"print",
		"|",
		"undo",
		"redo",
		"|",
		"image",
	],
	showXPathInStatusbar: false,
};

export const baseUrl = process.env.REACT_APP_STAGING_BACKEND_URL;

const Editor = ({
	state,
	onChange,
	classEditor,
	label,
	classLabel,
	tooltip,
	place,
	button,
	loading,
	classEditorMain,
}) => {
	const getFileBase64 = async (f, callback) => {
		const formData = new FormData();
		formData.append("image", f);
		const res = await upload(formData);
		if (res) {
			callback(res.core_image_url);
		}
	};

	const [{ isLoading }, upload] = UseApi({
		service: UploadImage,
		config: {
			headers: {
				"Content-Type": "Multipart/form-data",
			},
			params: {
				miniSize: "NO",
				whereFolder: "BRANDS",
			},
		},
	});

	return (
		<div
			className={cn(
				styles.editor,
				{ [styles.editorButton]: button },
				classEditor
			)}
		>
			{label && (
				<div className={cn(classLabel, styles.label)}>
					{label} &nbsp;
					{loading && <Loader className={styles.loader} />}
					{tooltip && (
						<Tooltip
							className={styles.tooltip}
							title={tooltip}
							icon="info"
							place={place ? place : "right"}
						/>
					)}
				</div>
			)}
			<ReactEditor
				editorState={state}
				toolbarClassName={styles.editorToolbar}
				wrapperClassName={styles.editorWrapper}
				editorClassName={cn(styles.editorMain, classEditorMain)}
				onEditorStateChange={onChange}
				toolbar={{
					options: [
						"inline",
						"image",
						// "emoji",
						"blockType",
						// "table",
						// "link",
						// "list",
						"textAlign",
						"history",
					],
				}}
			/>
			{button && (
				<button className={cn("button-small", styles.button)}>
					{button}
				</button>
			)}
		</div>
	);
};

export default Editor;
